import React from 'react'
import CommonBanner from '../component/Common/CommonBanner'
import HotelDetailsArea from 'component/HotelDetails'
import { useTranslation } from 'react-i18next';
const HotelDetails = () => {
  const { t } = useTranslation();
  return (
    <>
    <CommonBanner heading={t("hotelDetails")} pagination="Booking submission"/>
    <HotelDetailsArea/>
    </>
  )
}

export default HotelDetails